import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Supplier',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET SupplierManagement
    getSuppliersSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET SupplierManagement
    getAllSupplierSuccess(state, action) {
      state.allData = action.payload.data;
    },

    addOrUpdateSuppliers(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getSuppliers(supplierType) {
  return async () => {
    try {
      const response = await get(`Supplier?supplierType=${supplierType}`);
      if (response.status) {
        dispatch(slice.actions.getSuppliersSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllSuppliers() {
  return async () => {
    try {
      const response = await get(`allSupplier`);
      if (response.status) {
        dispatch(slice.actions.getAllSupplierSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addSupplier(body) {
  return async () => {
    try {
      const response = await post(`Supplier`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSuppliers(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateSupplier(body) {
  return async () => {
    try {
      const response = await put(`Supplier`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSuppliers(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
